import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import { makeStyles } from '@mui/styles';

// Components
import AutocompleteDropdown from '../../common/autocompleteDropdown/AutocompleteDropdown';

const useStyles = makeStyles(() => ({
  formControl: {
    minWidth: 200,
  },
  select: {
    height: '50px',
    width: '205px',
  },
}));

const IndividualValueEditForm = ({
  updatedValue,
  handleCreditChange,
  handleSelectBusiness,
  updatedCreditBusinessId,
  selectOptions,
  onSave,
  error,
  headerText,
  creditReasons,
  disableCreditReasons = false,
  selectedCreditReasonId,
  handleCreditReasonChange,
}) => {
  // Material styles
  const materialClasses = useStyles();

  return (
    <div className="individual-value-edit-form-container">
      <h1 className="individual-value-edit-form-content-header">{headerText}</h1>
      <div className="individual-value-edit-form-content">
        <div className="individual-value-edit-form-content-row">
          <h1 className="individual-value-edit-form-content-row-label">Select a business</h1>
          <div className="individual-value-edit-form-content-input">
            <FormControl variant="outlined" className={materialClasses.formControl}>
              <AutocompleteDropdown
                id="individual-value-edit-select"
                selectedData={updatedCreditBusinessId}
                onChange={handleSelectBusiness}
                label="Select Business"
                selectData={selectOptions}
              />
            </FormControl>
          </div>
        </div>

        <div className="individual-value-edit-form-content-row">
          <h1 className="individual-value-edit-form-content-row-label">Credit Reasons</h1>
          <div className="individual-value-edit-form-content-input">
            <FormControl variant="outlined" className={materialClasses.formControl}>
              <AutocompleteDropdown
                id="individual-value-edit-select"
                selectedData={selectedCreditReasonId}
                onChange={handleCreditReasonChange}
                label="Status"
                selectData={creditReasons}
                disabled={disableCreditReasons}
              />
            </FormControl>
          </div>
        </div>
        <div className="individual-value-edit-form-content-row">
          <h1 className="individual-value-edit-form-content-row-label">Add Credit</h1>
          <div className="individual-value-edit-form-content-input">
            <TextField
              variant="outlined"
              label="Add Credit"
              type="number"
              value={updatedValue}
              onChange={(event) => {
                handleCreditChange(event.target.value);
              }}
              className={materialClasses.inputRoot}
            />
          </div>
        </div>
      </div>
      <div className="individual-value-edit-form-content">
        {error && <p className="error-text">{error}</p>}
        <button
          className="individual-value-edit-submit-button"
          onClick={() => {
            onSave();
          }}
        >
          Save Changes
        </button>
      </div>
    </div>
  );
};

IndividualValueEditForm.propTypes = {
  currentValue: PropTypes.string,
  updatedValue: PropTypes.string,
  handleCreditChange: PropTypes.func,
  selectOptions: PropTypes.number,
  onSave: PropTypes.func,
  error: PropTypes.string,
  'selectOptions.map': PropTypes.number,
  headerText: PropTypes.string,
  handleSelectBusiness: PropTypes.func,
  updatedCreditBusinessId: PropTypes.number,
  creditReasons: PropTypes.array,
  disableCreditReasons: PropTypes.bool,
  selectedCreditReasonId: PropTypes.number,
  handleCreditReasonChange: PropTypes.func,
};

export default IndividualValueEditForm;
